export interface FormatNumberOptions {
  /** Fraction digits for toFixed. Default 2. */
  decimals?: number;
  /** Marker returned for NaN/±Infinity. Default '—'. */
  nonFinite?: string;
  /** Render exact integers without decimals. Default false. */
  trimIntegers?: boolean;
}

export function formatNumber(v: number, opts: FormatNumberOptions = {}): string {
  const { decimals = 2, nonFinite = '—', trimIntegers = false } = opts;
  if (!Number.isFinite(v)) return nonFinite;
  if (trimIntegers && Number.isInteger(v)) return String(v);
  return v.toFixed(decimals);
}
